import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaHeart, FaUsers, FaCalendarAlt, FaMapMarkerAlt, FaQuoteLeft } from 'react-icons/fa';
import './AboutPage.css';

const AboutPage = () => {
  const coupleData = {
    startDate: '2023-02-14',
    meetingPlace: '城市图书馆',
    relationshipDays: Math.floor((new Date() - new Date('2023-02-14')) / (1000 * 60 * 60 * 24)),
    person1: {
      name: '小明',
      age: 25,
      hobby: '摄影、旅行、音乐',
      personality: '温柔体贴，幽默风趣',
      favoriteColor: '#4A90E2',
      quote: '遇见你是我最美的意外'
    },
    person2: {
      name: '小美',
      age: 23,
      hobby: '绘画、读书、烹饪',
      personality: '善良可爱，聪明伶俐',
      favoriteColor: '#FF69B4',
      quote: '和你在一起的每一天都是最好的一天'
    }
  };

  const milestones = [
    { date: '2023-02-14', event: '初次相遇', description: '在图书馆里，一本书让我们相识' },
    { date: '2023-02-20', event: '第一次约会', description: '紧张而美好的咖啡时光' },
    { date: '2023-03-01', event: '确定关系', description: '月圆之夜，我们成为了彼此的唯一' },
    { date: '2023-05-20', event: '第一次旅行', description: '海边的日落见证了我们的约定' },
    { date: '2023-08-15', event: '见家长', description: '家人的祝福让爱情更加坚定' },
    { date: '2024-02-14', event: '一周年纪念', description: '365天的陪伴，无数个美好瞬间' }
  ];

  return (
    <motion.div
      className="about-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="about-container">
        <motion.div
          className="about-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          <Link to="/" className="back-btn">
            <FaArrowLeft /> 返回首页
          </Link>
          <h1 className="about-title">
            <FaUsers className="title-icon" />
            关于我们
            <FaHeart className="title-icon" />
          </h1>
          <p className="about-subtitle">我们的爱情故事从这里开始</p>
        </motion.div>

        <motion.div
          className="love-stats"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          <div className="stat-card">
            <div className="stat-icon">
              <FaCalendarAlt />
            </div>
            <div className="stat-info">
              <div className="stat-number">{coupleData.relationshipDays}</div>
              <div className="stat-label">天在一起</div>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">
              <FaMapMarkerAlt />
            </div>
            <div className="stat-info">
              <div className="stat-text">{coupleData.meetingPlace}</div>
              <div className="stat-label">初次相遇</div>
            </div>
          </div>
          
          <div className="stat-card">
            <div className="stat-icon">
              <FaHeart />
            </div>
            <div className="stat-info">
              <div className="stat-text">{coupleData.startDate}</div>
              <div className="stat-label">恋爱开始</div>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="couple-profiles"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6, duration: 0.8 }}
        >
          <div className="profile-card" style={{ borderColor: coupleData.person1.favoriteColor }}>
            <div className="profile-avatar" style={{ background: `linear-gradient(45deg, ${coupleData.person1.favoriteColor}, ${coupleData.person1.favoriteColor}80)` }}>
              👨
            </div>
            <h3 className="profile-name">{coupleData.person1.name}</h3>
            <div className="profile-age">{coupleData.person1.age} 岁</div>
            <div className="profile-details">
              <div className="detail-item">
                <strong>爱好:</strong> {coupleData.person1.hobby}
              </div>
              <div className="detail-item">
                <strong>性格:</strong> {coupleData.person1.personality}
              </div>
            </div>
            <div className="profile-quote">
              <FaQuoteLeft className="quote-icon" />
              <p>"{coupleData.person1.quote}"</p>
            </div>
          </div>

          <div className="love-symbol">
            <motion.div
              className="heart-animation"
              animate={{ scale: [1, 1.2, 1] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              💕
            </motion.div>
          </div>

          <div className="profile-card" style={{ borderColor: coupleData.person2.favoriteColor }}>
            <div className="profile-avatar" style={{ background: `linear-gradient(45deg, ${coupleData.person2.favoriteColor}, ${coupleData.person2.favoriteColor}80)` }}>
              👩
            </div>
            <h3 className="profile-name">{coupleData.person2.name}</h3>
            <div className="profile-age">{coupleData.person2.age} 岁</div>
            <div className="profile-details">
              <div className="detail-item">
                <strong>爱好:</strong> {coupleData.person2.hobby}
              </div>
              <div className="detail-item">
                <strong>性格:</strong> {coupleData.person2.personality}
              </div>
            </div>
            <div className="profile-quote">
              <FaQuoteLeft className="quote-icon" />
              <p>"{coupleData.person2.quote}"</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="timeline-section"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          <h2 className="timeline-title">我们的重要时刻</h2>
          <div className="timeline">
            {milestones.map((milestone, index) => (
              <motion.div
                key={index}
                className="timeline-item"
                initial={{ x: index % 2 === 0 ? -50 : 50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ delay: 1 + index * 0.2, duration: 0.6 }}
              >
                <div className="timeline-date">{milestone.date}</div>
                <div className="timeline-content">
                  <h4 className="timeline-event">{milestone.event}</h4>
                  <p className="timeline-description">{milestone.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="about-footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.8 }}
        >
          <div className="footer-message">
            <FaHeart className="heart-icon" />
            <h3>愿我们的爱情故事永远续写下去</h3>
            <p>从相遇到相知，从相知到相爱，每一个瞬间都值得珍藏。<br />
               未来的路还很长，但有你在身边，我就不怕任何风雨。</p>
            <FaHeart className="heart-icon" />
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default AboutPage;


